module.exports = __webpack_public_path__ + "img/zapermenu-min.688ee9ff.png";